module.exports = __webpack_public_path__ + "img/icon_late.7507f85e.svg";